import { Point } from "./Point";
import { Attachment } from "./Attachment";
/**
 * This JS file constructs the attachments object that is used to represent the attachments layer on 
 * the map.  The builder takes some raw attachments, a floor to build the layer for, and a 
 * geo-rereference for the drawing that the attachments will be plotted on. 
 **/
// example attachments object
const output_example = {
    "id_room": {
        adj_coord: [1, 2],
        attachments: [
            {
                url: "",
                id_attachment: ""
            },
            {
                url: "",
                id_attachment: ""
            }
        ]
    }
}
const input_example = {}

/**
 * attachements object 
 */
export function MapMakeAttachmentsLayer(attachments_list: any[],
    id_floor: number,
    drawing_p1_x: number,
    drawing_p1_y: number,
    drawing_p2_x: number,
    drawing_p2_y: number,
    repositioning_icon:string
): Object {
    id_floor += 89;
    let p1 = Point.build(drawing_p1_x, drawing_p1_y);
    let p2 = Point.build(drawing_p2_x, drawing_p2_y);

    let attachments: Attachment[];
    // step 1, filter out all attachments that are not on the floor of interest and convert the json into an Attachments object
    for (var attachment of attachments_list) {
        if (attachment.id_location == id_floor) {
            let url = attachment.url
            let coord = Point.build(attachment.coord[0], attachment.coord[1])
            let p1 = Point.build(attachment.p1[0], attachment.p1[1])
            let p2 = Point.build(attachment.p2[0], attachment.p2[1])
            attachments.push(new Attachment(null, url, coord, p1, p2, "", attachment.id_room, repositioning_icon));  // AWH this is a bad idea...
        }
    }

    let output = {
        12345: {
            adj_coord: [1, 2],
            attachments: [
                {
                    url: "",
                    id_attachment: ""
                },
                {
                    url: "",
                    id_attachment: ""
                }
            ]
        },
        54321: {
            adj_coord: [99, 88],
            attachments: [
                {
                    url: "",
                    id_attachment: ""
                },
                {
                    url: "",
                    id_attachment: ""
                }
            ]
        }
    }
    return output;
}


// WEBPACK FOOTER //
// ./src/ts/map_attachments.ts